export default __webpack_public_path__ + "media/integrations/commandline-8439eda9.svg";